<template>

    <div class="outer-authorized">
        <div class="middle">
            <div class="inner">
                <div class="titles text-cna d-table text-center" style="border-radius: 5%;">
                    <h3 class="uppercase d-table-cell align-middle" style=" font-size: 18px;">
                        <b>Acesso realizado com sucesso.</b><br />
                        <button class="btn btn-outline-danger mt-4" @click="acessarShopping()">Acessar o Shopping CNA</button>
                        <button class="btn btn-outline-danger mt-4" @click="acessarCNANet()">Acessar o CNA Net</button>
                    </h3>
                </div>
            </div>
        </div>
    </div>


</template>
<script>

    import Auth from '@/common/auth'
    import Global from '@/common/global'
    import Cache from '@/common/cache'
    import { Api } from '@/common/api'

    export default {
        name: 'authorized',
        methods: {
            acessarShopping() {
                window.location = Global.URL_SHOPPING_CNA;
            },
            acessarCNANet() {
                window.location = Global.URL_CNA_NET;
            }
        },
        mounted() {
        }
    }
</script>

